import type React from "react";
import Button from "~/components/ui/button";
import companyLogo from "~/images/companyLogo.png";
import styles from "./index.module.scss";

interface CancelCompleteReqxignModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const CancelCompleteReqxign: React.FC<CancelCompleteReqxignModalProps> = ({ isOpen, onClose }) => {
  const moveToLP = () => {
    onClose();
    window.open("https://www.reqxign.net/", "_blank");
  };

  const moveToQuiz = () => {
    onClose();
    const feedbackUrl = "https://novelworks.chobiit.me/list_app.html";
    window.open(feedbackUrl, "_blank");
  };

  if (!isOpen) return null;

  return (
    <div className={styles["overlay"]}>
      <div
        className={styles["modal"]}
        style={{
          width: "640px",
        }}
      >
        <img src={companyLogo} alt="Company Logo" />
        <div className={styles["modalBody"]}>
          <div className={styles["header-container_cancel"]}>ご利用ありがとうございました！</div>
          <div className={styles["form-description_cancel"]}>
            いつでもお帰りをお待ちしております。
          </div>
          <div className="flex flex-col gap-[16px] justify-center">
            <Button
              label="REQXiGN製品サイトへ"
              onClick={moveToLP}
              heightType="blue-cancel-complete"
            />

            <div className="text-center text-[16px] font-sans">
              ✉️ ご意見・ご要望があれば
              <span className="text-lightblue hover:underline cursor-pointer" onClick={moveToQuiz}>
                こちらから
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancelCompleteReqxign;
